"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function AccountBackupIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M0,0H24V24H0Z", fill: "none" }),
        react_1.default.createElement("path", { d: "M12,21.85v-1.7A8.15,8.15,0,1,0,3.85,12H2.15A9.85,9.85,0,1,1,12,21.85Z" }),
        react_1.default.createElement("polygon", { points: "8.243 14.74 12 7.986 15.758 14.74 8.243 14.74" }),
        react_1.default.createElement("path", { d: "M12.009,21.85H12a9.854,9.854,0,0,1-1.092-.06l.186-1.689A8.465,8.465,0,0,0,12,20.15Z" }),
        react_1.default.createElement("path", { d: "M9.819,21.608a9.737,9.737,0,0,1-1.063-.3l.56-1.6a8.334,8.334,0,0,0,.878.251Z" }),
        react_1.default.createElement("path", { d: "M7.736,20.881a9.817,9.817,0,0,1-.966-.533l.9-1.441a8.191,8.191,0,0,0,.8.442Z" }),
        react_1.default.createElement("path", { d: "M5.868,19.709a9.914,9.914,0,0,1-.824-.735l1.2-1.2a8.2,8.2,0,0,0,.682.608Z" }),
        react_1.default.createElement("path", { d: "M4.309,18.153a9.837,9.837,0,0,1-.642-.9L5.1,16.345a8.226,8.226,0,0,0,.531.745Z" }),
        react_1.default.createElement("path", { d: "M3.132,16.291a9.773,9.773,0,0,1-.426-1.022l1.6-.563a7.68,7.68,0,0,0,.351.841Z" }),
        react_1.default.createElement("path", { d: "M2.4,14.208a10.169,10.169,0,0,1-.185-1.086l1.689-.2a8.426,8.426,0,0,0,.155.9Z" })));
}
exports.default = AccountBackupIcon;
